import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "./api";
import {handleResponseStatus} from "./utils";

const initialState = {
    items: [],
    fetchStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    monthFilterStatus: false, // track last API type
    monthRange: {},
    formRange:{},
    error: null
};


export const fetchFinancialReport = createAsyncThunk('financial/fetchFinancialReport', async ({
                                                                                                  roleSign,
                                                                                                  scopeId,
                                                                                                  formData = {
                                                                                                      start: '',
                                                                                                      end: ''
                                                                                                  }
                                                                                              } = {}) => {
        try {
            const {start, end} = formData;
            const params = new URLSearchParams();

            if (start) params.append("start", start);
            if (end) params.append("end", end);

            const queryString = params.toString();
            const fullParams = queryString ? `&${queryString}` : '';

            const response = await api.get(`/${roleSign}/getProfitLoss?id=${scopeId}${fullParams}`);
            return {...response};
        } catch (error) {
            if (error.response) return error.response;
            throw error;
        }
    }
);

const financialReportSlice = createSlice({
    name: "financialReport",
    initialState,
    reducers: {
        setMonthFilterStatus(state) {
            state.monthFilterStatus = true;
        },
        resetMonthFilterStatus(state) {
            state.monthFilterStatus = false;
        },
        setRangeMonth(state, action) {
            state.monthRange = {
                ...action.payload
            };
        },
        setFormMonthRange(state, action) {
            state.formRange = {
                ...action.payload
            };
        }
    },
    extraReducers: (builder) => {
        builder

            // Fetch financial report
            .addCase(fetchFinancialReport.pending, (state) => {
                state.fetchStatus = 'loading';
            })
            .addCase(fetchFinancialReport.fulfilled, (state, action) => {
                const {fetchStatus, error} = handleResponseStatus(action.payload, 'fetchStatus');
                const {data} = action.payload;
                state.items = fetchStatus === "success" ? data : state.items;
                state.fetchStatus = fetchStatus;
                state.error = error;
            })
            .addCase(fetchFinancialReport.rejected, (state, action) => {
                state.fetchStatus = 'failed';
                state.error = action.error.message;
            })

    }
});

export const {setRangeMonth, resetMonthFilterStatus, setMonthFilterStatus,setFormMonthRange} = financialReportSlice.actions;
export default financialReportSlice.reducer;
